/**
 * Authentication is handled on ThousandEyes side
 * A valid user will have a valid JSESSONID Cookie which can't be read by the browser
 * We can only check the user is not authenticated anymore via an API call.
 * If it succeeds, user is logged in
 * If it fails, user needs to login again
 *
 * @returns {Promise<boolean>}
 */
export async function isThousandEyesUserLoggedIn(): Promise<boolean> {
  try {
    const response = await fetch('/auth/validate');

    return response.ok;
  } catch {
    return false;
  }
}
